import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { createColumnHelper } from '@tanstack/react-table'

import Table from '@/components/ui/tables/Table'

export type LicenseComponentData = {
  id: string
  name: string
  type: string
}

export type LicenseComponentsTableProps = {
  data: LicenseComponentData[]
  loading?: boolean
}

export const columnHelper = createColumnHelper<LicenseComponentData>()

export function LicenseComponentsTable(props: LicenseComponentsTableProps) {
  const { data, loading } = props

  const { t } = useTranslation()

  const columns = useMemo(() => {
    return [
      columnHelper.accessor('name', {
        header: t('table.licenseComponents.header.name').toString(),
      }),
      columnHelper.accessor('type', {
        header: t('table.licenseComponents.header.type').toString(),
      }),
    ]
  }, [t])

  return <Table columns={columns} disableGlobalSearch data={data} loading={loading} />
}

export default LicenseComponentsTable
